import axios from "axios";
import { BASE_URL } from "./api";

export async function getResearchAssignments(token, queryParams) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/research_assignments${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function getResearchAssignmentsByUser(token, userId, researchPage) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/research_assignments/get_unpaginated_response?user=${userId}&research_page=${researchPage}`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function getAllResearchAssignments(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/research_assignments/get_unpaginated_response`,
        headers: {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function updateResearchAssignment(researchAssignmentId, formData, token) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/research_assignments/${researchAssignmentId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: formData
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}